import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum ESetIsB2BForbiddingMessageShownActionType {
  Set = 'user/setIsB2BForbiddingMessageShown/set',
}

export type TIsB2BForbiddingMessageShown = ITypedReduxAction<ESetIsB2BForbiddingMessageShownActionType.Set, boolean>;
